import { useState } from 'react';

export default function MultiCheckbox({ options = [], selected, onChange = () => {}, name }) {
  const [internalSelected, setInternalSelected] = useState([]);

  const current = selected !== undefined ? selected : internalSelected;

  const toggleValue = (value) => {
    const already = current.includes(value);
    const next = already ? current.filter((v) => v !== value) : [...current, value];

    if (selected === undefined) setInternalSelected(next);
    onChange(next);
  };

  return (
    <fieldset>
      <div className="flex flex-col gap-4">
        {options.map((opt, idx) => {
          const id = `${name || 'multi-checkbox'}-${idx}-${String(opt.value)}`;
          const checked = current.includes(opt.value);
          return (
            <label
              key={opt.value}
              htmlFor={id}
              className="flex items-center gap-2 cursor-pointer select-none text-light dark:text-dark"
            >
              <input
                id={id}
                name={name}
                type="checkbox"
                checked={checked}
                onChange={() => toggleValue(opt.value)}
                value={opt.value}
                className={`m-0 flex-none cursor-pointer rounded-md border-2 ${
                  checked
                    ? 'border-blue bg-blue shadow-[inset_0_0_0_4px_white] dark:shadow-[inset_0_0_0_4px_#38363E]'
                    : 'border-gray bg-transparent shadow-none'
                }`}
                style={{
                  width: 20,
                  height: 20,
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                }}
              />
              <span className="text-sm">{opt.label}</span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
